module.exports = __webpack_public_path__ + "static/cloud-illustration-0f2b51c0a2d3c3e08dfa72e9dd61f9e3.svg";